
import { computed, defineComponent, inject, PropType, ref, watch } from "vue";

import {
  NBadge,
  NCard,
  NGrid,
  NGridItem,
  NIcon,
  NSpace,
  useThemeVars,
} from "naive-ui";

import { useDebounceFn } from "@vueuse/core";

import {
  BrightnessHigh20Filled,
  Lightbulb20Regular,
  LightbulbFilament20Regular,
} from "@vicons/fluent";

import { Asset, AssetData } from "@/models/asset.model";

import { useAssetsStore } from "@/stores/assets.store";

import DrawerComponent from "./components/DrawerComponent.vue";

export default defineComponent({
  name: "DimmActuatorComponent",

  props: {
    asset: {
      type: Object as PropType<Asset>,
      required: true,
    },

    data: {
      type: Object as PropType<AssetData[]>,
      required: true,
    },
  },

  components: {
    NBadge,
    NCard,
    NGrid,
    NGridItem,
    NIcon,
    NSpace,

    BrightnessHigh20Filled,
    DrawerComponent,
    Lightbulb20Regular,
    LightbulbFilament20Regular,
  },

  setup(props) {
    const themeVars = useThemeVars();
    const assetsStore = useAssetsStore();

    const fb = computed(() => props.data.find((_) => _.subtype == ""));

    const attrDrawer = ref(false);
    const sliderValue = ref(fb.value?.data.dimming_fb ?? 0);

    const debounceSetSpData = useDebounceFn(setSpData, 1000);

    watch(
      () => fb.value?.data,
      (value, oldValue) => {
        if (value?.dimming_fb != oldValue?.dimming_fb) {
          sliderValue.value = value?.dimming_fb ?? 0;
        }
      }
    );

    function setCmdData(event: Event) {
      let switch_cmd: number;

      if (event.type == "click") switch_cmd = +!fb.value?.data.switch_cmd;
      else switch_cmd = +event;

      const payload = {
        asset_id: props.asset.asset_id,
        subtype: "cmd",
        data: {
          switch_cmd: switch_cmd,
        },
      };

      assetsStore.setAssetData(payload);
    }

    function setSpData(event: number) {
      attrDrawer.value = false;

      const payload = {
        asset_id: props.asset.asset_id,
        subtype: "sp",
        data: {
          dimming_sp: event,
        },
      };

      assetsStore.setAssetData(payload);
    }

    return {
      env: inject("env"),

      themeVars,
      attrDrawer,
      sliderValue,
      fb,

      debounceSetSpData,
      setCmdData,
    };
  },
});
